import { putGame } from '../api/putGame';

export const setPutGame = (params) => {
    return async (dispatch, getState) => {
        try {
            await putGame(params);
            alert('Сохранено')
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}